"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRange = function (x, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 1; }
    return min + (max - min) * x;
};
exports.arrayMean = function (array) {
    if (array.length === 0) {
        return undefined;
    }
    return (array.reduce(function (current, next) {
        return current + next;
    }, 0) / array.length);
};
